import { useToggleSwapCertificatesMutation } from 'autogen/swagger/all/hooks';
import styled from 'styled-components';
import { Typography } from 'components/generic/typography';
import React, { useState } from 'react';
import CheckBox from 'components/shared/inputs/checkbox';
import {
    BorderRadiusMedium,
    ColorNordicGrey1,
    ColorNordicGrey4,
    Spacing12,
    Spacing8
} from 'autogen/design-tokens/tokens';
import { useTranslation } from 'react-i18next';
import { SwapCertificateToggle } from 'autogen/translation-keys/trans-website-basket';
import { rem } from 'modules/helpers/style';
import toast from 'components/Toast';
import { GeneralExceptionError } from 'autogen/translation-keys/trans-website-shared-error';

const Label = styled.label`
    padding: ${Spacing12};
    display: flex;
    align-items: center;
    gap: ${Spacing8};
    background-color: ${ColorNordicGrey4};
    border-radius: ${BorderRadiusMedium};
    align-self: start;
    height: ${rem(40)};
    margin: 0;
`;

const Divider = styled.div`
    display: block;
    width: 100%;
    height: 1px;
    background: ${ColorNordicGrey1};
`;

export default function SwapCertificateButton({
    initialSwapCertificateState
}: { initialSwapCertificateState: boolean }) {
    const { t } = useTranslation();
    const [hasSwapCertificate, setHasSwapCertificate] = useState(initialSwapCertificateState);
    const { mutateAsync: updateSwapCertificate } = useToggleSwapCertificatesMutation();

    const optimisticUpdate = (swapCertificate: boolean) => {
        setHasSwapCertificate(swapCertificate);

        return {
            revert: () => {
                setHasSwapCertificate(!swapCertificate);
            }
        };
    };

    async function handleToggle() {
        const update = optimisticUpdate(!hasSwapCertificate);
        try {
            const params = { hasSwapCertificate: !hasSwapCertificate };
            const response = await updateSwapCertificate({ params });

            if (!response.success) throw new Error();
        } catch (error) {
            if (update) update.revert();
            toast.error(t(GeneralExceptionError));
        }
    }

    return (
        <>
            <Divider />
            <Label>
                <CheckBox checked={hasSwapCertificate} onChange={handleToggle} />
                <Typography.Body as="span">{t(SwapCertificateToggle)}</Typography.Body>
            </Label>
        </>
    );
}
